import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { logoutUser } from '../firebase/auth';
import { updateUserProfile } from '../firebase/db';
import DemoToggle from '../components/DemoToggle';
import './Profile.css';

const Profile = () => {
  const { user, profile, refreshProfile, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(profile?.displayName || '');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    await updateUserProfile(user.uid, { displayName: name });
    await refreshProfile();
    setEditing(false);
    setSaving(false);
  };

  const handleLogout = async () => {
    await logoutUser(user.uid);
    navigate('/login');
  };

  return (
    <div className="page profile">
      <h2>Profile</h2>

      <div className="prof-card">
        <div className="prof-avatar">
          {profile?.photoURL ? (
            <img src={profile.photoURL} alt="avatar" />
          ) : (
            <div className="prof-avatar-placeholder">{profile?.displayName?.[0] || '?'}</div>
          )}
        </div>

        {editing ? (
          <div className="prof-edit">
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" />
            <button className="btn-primary" onClick={handleSave} disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </button>
            <button className="btn-secondary" onClick={() => setEditing(false)}>
              Cancel
            </button>
          </div>
        ) : (
          <div className="prof-info">
            <h3>{profile?.displayName || user?.email}</h3>
            <p className="prof-email">{user?.email}</p>
            <p className="prof-role">{profile?.role === 'admin' ? 'Admin' : 'Field Worker'}</p>
            <button className="btn-secondary" onClick={() => setEditing(true)}>
              ✏️ Edit Name
            </button>
          </div>
        )}
      </div>

      {isAdmin && (
      <div className="prof-section">
        <h4>Settings</h4>
        <DemoToggle />
      </div>
      )}

      <button className="logout-btn" onClick={handleLogout}>
        Log Out
      </button>
    </div>
  );
};

export default Profile;
